import { useEffect, useState } from 'react';

interface Props {
  /** Unix ms when the rate-limit window expires; null disables. */
  deadlineMs: number | null;
  className?: string;
}

export function RateLimitInline({ deadlineMs, className }: Props) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (deadlineMs === null) return;
    const id = window.setInterval(() => setNow(Date.now()), 500);
    return () => window.clearInterval(id);
  }, [deadlineMs]);

  if (deadlineMs === null) return null;
  const remaining = Math.max(0, Math.ceil((deadlineMs - now) / 1000));
  if (remaining === 0) return null;

  return (
    <p className={className ?? 'text-xs text-amber-900 font-medium mb-3'}>
      Too many attempts. Please wait{' '}
      <span className="font-bold">
        {remaining} second{remaining === 1 ? '' : 's'}
      </span>{' '}
      and try again.
    </p>
  );
}

export function isRateLimited(deadlineMs: number | null): boolean {
  return deadlineMs !== null && deadlineMs > Date.now();
}
